import React from 'react'

const Github = () => {
  return (
    <div name='home' className='w-full bg-[#0a192f]'>
    {/* Container */}
    <div className='max-w-[1000px] mx-auto flex flex-col justify-center'>
        <img src="https://raw.githubusercontent.com/AnilBASARAN/AnilBASARAN/output/dist/snake.svg" alt="Snake" />
    </div>
    </div>
  )
}

export default Github